exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".table-scrollable[_v-458c26dc]{max-height:383px;overflow-y:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-458c26dc&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/tables/table-t4/modal/infomodal.vue
// module id = 173
// module chunks = 0